import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}video/session`;

interface VideoSessionSummaryDto {
  sessionId: string;
  url: string;
}

interface CreateVideoSessionCommandPayload {
  fileId: string;
  phone: string;
}

export const createVideoSessionCommand = async ({
  fileId,
  phone,
}: CreateVideoSessionCommandPayload): Promise<
  BackResponse<VideoSessionSummaryDto> | BackResponseFailure
> => {
  try {
    const forceLocalhost = window.location.hostname === 'localhost';

    return await apiCall<BackResponse<VideoSessionSummaryDto>>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: { fileId, phone, forceLocalhost },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
